import { ThemeProvider } from '@tl4k/frontend-shared';
import App from './src/editor/App';

export default function SvgEditRootApp() {
  return (
    <ThemeProvider ageGroup="7-10">
      <App />
    </ThemeProvider>
  );
}
